import React, { useState, useEffect } from "react";
import { Redirect, useHistory } from "react-router-dom";
import "./FormularioDiplomas.css";
import generarLineaCaptura from "../utilities/GenerarLineaCaptura";
import { usePagoVentanilla } from "../hooks/usePagoVentanilla";
import { plantelDeMatricula } from "../utilities/plantel";
import { AvisoCatalogo } from "./FormularioExamen";

// Si el alumno regresa desde Forma de pago, la tabla que dejo este formulario trae lo que habia elegido: se
// recupera de ahi (antes volvia al paquete completo sin diplomas). Si la tabla es de otro formulario, null.
//   paquete (clave 50 + N diplomas) -> los tres documentos y N diplomas
//   documentos sueltos (04, 37, 38) y diplomas (11) -> lo que venga en la tabla
export const seleccionEgresadosDesdeTabla = (tabla) => {
  if (!Array.isArray(tabla) || tabla.length === 0) return null;
  const claves = tabla.map((t) => t.clave);
  const paquete = claves.find((c) => /^5[0-5]$/.test(c));
  if (paquete) {
    if (claves.length !== 1) return null;
    return { conceptos: { certificado: true, noAdeudo: true, servicioSocial: true }, diplomas: Number(paquete) - 50 };
  }
  if (!claves.every((c) => ["04", "37", "38", "11"].includes(c))) return null;
  return {
    conceptos: { certificado: claves.includes("04"), noAdeudo: claves.includes("37"), servicioSocial: claves.includes("38") },
    diplomas: Math.min(5, claves.filter((c) => c === "11").length),
  };
};

const FormularioDiplomas = ({
  conceptos = [],
  estadoCatalogo = "listo",
  alumno,
  precio,
  cambiarPrecio,
  cambiarPagar = () => {},
  cambiarDatosPago,
  cambiarTablaConceptos,
  tablaConceptos,
}) => {
  const history = useHistory();
  const { cargandoPdf, generarFolioTPV, guardarIntencionBD, descargarPdf } = usePagoVentanilla(alumno);

  const [seleccionPrevia] = useState(() => seleccionEgresadosDesdeTabla(tablaConceptos));
  const [conceptosSeleccionados, setConceptosSeleccionados] = useState(
    seleccionPrevia ? seleccionPrevia.conceptos : { certificado: true, noAdeudo: true, servicioSocial: true }
  );
  const [numDiplomas, setNumDiplomas] = useState(seleccionPrevia ? seleccionPrevia.diplomas : 0);
  const [error, cambiarError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");
  const [esSoloVentanilla, setEsSoloVentanilla] = useState(false);
  const [fechaVencimiento, setFechaVencimiento] = useState("");
  // Evita volver a guardar la intencion en cada clic de "Descargar" (ya
  // guardada la primera vez, los clics siguientes solo vuelven a descargar
  // el mismo PDF). Mismo patron que ya usa FormaPago.js.
  const [intencionGuardada, setIntencionGuardada] = useState(false);


  const handleCheckboxChange = (e) => {
    setConceptosSeleccionados({
      ...conceptosSeleccionados,
      [e.target.name]: e.target.checked,
    });
  };

  // Solo se ofrece lo que existe y esta activo en el catalogo. Antes habia precios y nombres de respaldo fijos en
  // el codigo: si un concepto se desactivaba o el catalogo no cargaba, se cobraba con un precio que podia ser viejo
  // (y con una clave que podia no existir en la BD).
  const getConceptoBD = (claveBuscada) => conceptos.find(c => c.clave === claveBuscada) || null;

  const cCertificado = getConceptoBD("04");
  const cNoAdeudo = getConceptoBD("37");
  const cServicio = getConceptoBD("38");
  const cDiploma = getConceptoBD("11");
  // Paquete completo (certificado + no adeudo + servicio social) con N diplomas = clave 50 + N (50 a 55)
  const paqueteCon = (diplomas) => getConceptoBD(String(50 + diplomas));

  // Seleccion efectiva: lo marcado Y disponible en el catalogo
  const sel = {
    certificado: conceptosSeleccionados.certificado && !!cCertificado,
    noAdeudo: conceptosSeleccionados.noAdeudo && !!cNoAdeudo,
    servicioSocial: conceptosSeleccionados.servicioSocial && !!cServicio,
  };
  const losTresMarcados = sel.certificado && sel.noAdeudo && sel.servicioSocial;
  // Si falta el paquete para ese numero de diplomas, se cobra cada documento por separado
  const esPaqueteCompleto = losTresMarcados && !!paqueteCon(numDiplomas);
  // Numero de diplomas que se puede elegir: con el paquete correspondiente o con el diploma suelto
  const diplomasDisponibles = (n) => n === 0 || !!cDiploma || (losTresMarcados && !!paqueteCon(n));
  const hayAlgoDisponible = !!(cCertificado || cNoAdeudo || cServicio || cDiploma);
  // El calculo se repite cuando llega o cambia el catalogo (antes se quedaba con lo calculado al entrar)
  const firmaCatalogo = conceptos.map(c => `${c.clave}:${c.precio}:${c.concepto}`).join("|");

  // Si el numero de diplomas elegido deja de estar disponible (p. ej. se desmarco un documento), vuelve a 0
  useEffect(() => {
    if (!diplomasDisponibles(numDiplomas)) setNumDiplomas(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conceptosSeleccionados, numDiplomas, firmaCatalogo]);

  useEffect(() => {
    let total = 0;
    let cuentaConceptos = 0;
    let tablaDesglose = [];

    const matriculaStr = String(alumno.codigo);
    const plantelOficialAlumno = plantelDeMatricula(matriculaStr);

    if (esPaqueteCompleto) {
      cuentaConceptos = 1;
      const paqueteDinamico = paqueteCon(numDiplomas);
            
      total = Number(paqueteDinamico.precio);
      tablaDesglose.push({ concepto: paqueteDinamico.concepto, clave: paqueteDinamico.clave, precio: paqueteDinamico.precio.toString() });
    } else {
      if (sel.certificado) {
        cuentaConceptos++;
        total += Number(cCertificado.precio);
        tablaDesglose.push({ concepto: cCertificado.concepto, clave: cCertificado.clave, precio: cCertificado.precio.toString() });
      }
      if (sel.noAdeudo) {
        cuentaConceptos++;
        total += Number(cNoAdeudo.precio);
        tablaDesglose.push({ concepto: cNoAdeudo.concepto, clave: cNoAdeudo.clave, precio: cNoAdeudo.precio.toString() });
      }
      if (sel.servicioSocial) {
        cuentaConceptos++;
        total += Number(cServicio.precio);
        tablaDesglose.push({ concepto: cServicio.concepto, clave: cServicio.clave, precio: cServicio.precio.toString() });
      }
      for (let i = 0; cDiploma && i < numDiplomas; i++) {
        cuentaConceptos++;
        total += Number(cDiploma.precio);
        tablaDesglose.push({ concepto: `${cDiploma.concepto} (${i + 1}/${numDiplomas})`, clave: cDiploma.clave, precio: cDiploma.precio.toString() });
      }
    }

    cambiarPrecio(total);
    const soloVentanilla = cuentaConceptos > 5;
    setEsSoloVentanilla(soloVentanilla);

    if (soloVentanilla) {
      const itemsBase = tablaDesglose.filter(item => ["04", "37", "38"].includes(item.clave));
      const itemsDiplomas = tablaDesglose.filter(item => item.clave === "11");

      let refBaseStr = "S/R", refBaseBBVA = "S/R";
      if (itemsBase.length > 0) {
        const importeBase = itemsBase.reduce((sum, item) => sum + Number(item.precio), 0);
        const clavesBase = itemsBase.map(item => item.clave);
        const datosRefBase = generarLineaCaptura(plantelOficialAlumno, clavesBase, matriculaStr, importeBase);
        refBaseStr = datosRefBase.banorte.lineaDeCaptura;
        refBaseBBVA = datosRefBase.bancomer.lineaDeCaptura;
        setFechaVencimiento(datosRefBase.banorte.fechaVencimientoStr);
      }

      let refDiplomasStr = "S/R", refDiplomasBBVA = "S/R";
      if (itemsDiplomas.length > 0) {
        const importeDiplomas = itemsDiplomas.reduce((sum, item) => sum + Number(item.precio), 0);
        const clavesDiplomas = itemsDiplomas.map(item => item.clave);
        const datosRefDiplomas = generarLineaCaptura(plantelOficialAlumno, clavesDiplomas, matriculaStr, importeDiplomas);
        refDiplomasStr = datosRefDiplomas.banorte.lineaDeCaptura;
        refDiplomasBBVA = datosRefDiplomas.bancomer.lineaDeCaptura;
        setFechaVencimiento(datosRefDiplomas.banorte.fechaVencimientoStr); 
      }

      // --- ASIGNACIÓN DE FOLIOS INDEPENDIENTES POR GRUPO ---
      const folioBase = generarFolioTPV();
      const folioDiplomas = generarFolioTPV();

      tablaDesglose = tablaDesglose.map((item, idx) => {
        const esDiploma = item.clave === "11";
        return {
          ...item,
          id: idx + 1,
          folioTPV: esDiploma ? folioDiplomas : folioBase, // <--- Folio individual por bloque
          referencias: {
            Banorte: esDiploma ? refDiplomasStr : refBaseStr,
            BBVA: esDiploma ? refDiplomasBBVA : refBaseBBVA 
          }
        };
      });

      setMensajeError("Límite de conceptos para pago en línea superado. Puedes descargar tu formato para pagar en ventanilla bancaria.");
      cambiarError(true);

    } else {
      if (tablaDesglose.length > 0) {
        const clavesTodas = tablaDesglose.map(item => item.clave);
        const datosRefUnica = generarLineaCaptura(plantelOficialAlumno, clavesTodas, matriculaStr, total);
        const folioUnico = generarFolioTPV();
        setFechaVencimiento(datosRefUnica.banorte.fechaVencimientoStr);

        tablaDesglose = tablaDesglose.map((item, idx) => ({
          ...item,
          id: idx + 1,
          folioTPV: folioUnico,
          referencias: {
            Banorte: datosRefUnica.banorte.lineaDeCaptura,
            BBVA: datosRefUnica.bancomer.lineaDeCaptura 
          }
        }));
      }
      cambiarError(false);
      setMensajeError("");
    }

    cambiarTablaConceptos(tablaDesglose);
    // La seleccion cambio -> nuevas referencias -> hay que poder guardarlas
    // de nuevo (el candado solo evita repetir el guardado por clics extra
    // sobre la MISMA seleccion).
    setIntencionGuardada(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conceptosSeleccionados, numDiplomas, alumno.codigo, firmaCatalogo]);

  const PrepararPagoVentanilla = async () => {
    if (!intencionGuardada) {
      if (esSoloVentanilla) {
        const itemsBase = tablaConceptos.filter(item => ["04", "37", "38"].includes(item.clave));
        const itemsDiplomas = tablaConceptos.filter(item => item.clave === "11");

        if (itemsBase.length > 0) {
          const folioBase = itemsBase[0].folioTPV || generarFolioTPV();
          const importeBase = itemsBase.reduce((sum, item) => sum + Number(item.precio), 0);
          await guardarIntencionBD(itemsBase, importeBase, itemsBase[0].referencias.Banorte, itemsBase[0].referencias.BBVA, folioBase, "VENTANILLA");
        }

        if (itemsDiplomas.length > 0) {
          const folioDiplomas = itemsDiplomas[0].folioTPV || generarFolioTPV();
          const importeDiplomas = itemsDiplomas.reduce((sum, item) => sum + Number(item.precio), 0);
          await guardarIntencionBD(itemsDiplomas, importeDiplomas, itemsDiplomas[0].referencias.Banorte, itemsDiplomas[0].referencias.BBVA, folioDiplomas, "VENTANILLA");
        }
      } else {
        const folioUnico = tablaConceptos[0]?.folioTPV || generarFolioTPV();
        const refUnicaBanorte = tablaConceptos[0]?.referencias?.Banorte || "S/R";
        const refUnicaBBVA = tablaConceptos[0]?.referencias?.BBVA || "S/R";
        await guardarIntencionBD(tablaConceptos, precio, refUnicaBanorte, refUnicaBBVA, folioUnico, "VENTANILLA");
      }
      setIntencionGuardada(true);
    }

    await descargarPdf(tablaConceptos, null, fechaVencimiento);
  };

  const CrearPagoOnline = async () => {
    if (precio === 0) {
      setMensajeError("Debes seleccionar al menos un concepto.");
      cambiarError(true);
      return;
    }
    const refM97 = tablaConceptos[0]?.referencias?.Banorte; 
    const importe = precio.toString().concat(".00");

    try {
      cambiarDatosPago({
        referencia: refM97,
        importe: importe,
        fechaVencimiento: fechaVencimiento
      });
      cambiarPagar(true);
      history.push("/formadepago");
    } catch (err) {
      setMensajeError("Error de conexión. Inténtalo más tarde.");
      cambiarError(true);
    }
  };

  return alumno.codigo === "" ? (
    <Redirect to="/login" />
  ) : (
    <div className="FormularioDiplomas-container container">
      <button className="FormularioDiplomas-btn-regresar" onClick={() => history.push("/tipo")}>
        &larr; Regresar
      </button>

      <div className="FormularioDiplomas-main-header">
        <h2>Paquete de Egresados</h2>
        <p className="main-subtitle">Si no requieres todos los documentos oficiales, puedes desmarcar los que no necesites para personalizar tu pago.</p>
      </div>

      {estadoCatalogo !== "listo" ? (
        <AvisoCatalogo estado={estadoCatalogo} />
      ) : !hayAlgoDisponible ? (
        <div className="Formulario-error">
          <p>Por ahora no hay documentos de egreso disponibles para pago en línea. Consulta en tu plantel.</p>
        </div>
      ) : (
      <>
      
      <div className="FormularioDiplomas-card">
        {esPaqueteCompleto ? (
          <div className="FormularioDiplomas-package-header">
            <h3>Costo Base <span>${Number((paqueteCon(0) || paqueteCon(numDiplomas)).precio).toFixed(2)}</span></h3>
            <p className="package-instruction-text">Este paquete incluye por defecto los siguientes documentos:</p>
          </div>
        ) : (
          <div className="FormularioDiplomas-package-header">
            <div className="custom-card-title-row">
              <h3>Selección Personalizada</h3>
              <span className="badge-max-concepts">Máximo 5 permitidos en línea</span>
            </div>
            <p className="package-instruction-text">Has desmarcado el paquete base. Selecciona individualmente los documentos que requieras:</p>
          </div>
        )}

        <hr className="FormularioDiplomas-divider" />
        
        <div className="FormularioDiplomas-checkbox-group">
          {cCertificado && (
          <label className="custom-egreso-checkbox">
            <input type="checkbox" name="certificado" checked={sel.certificado} onChange={handleCheckboxChange} />
            <span className="custom-checkmark"></span>
            <span className="checkbox-label-text">{cCertificado.concepto}</span>
            {!esPaqueteCompleto && <span className="individual-price">${Number(cCertificado.precio).toFixed(2)}</span>}
          </label>
          )}

          {cServicio && (
          <label className="custom-egreso-checkbox">
            <input type="checkbox" name="servicioSocial" checked={sel.servicioSocial} onChange={handleCheckboxChange} />
            <span className="custom-checkmark"></span>
            <span className="checkbox-label-text">{cServicio.concepto}</span>
            {!esPaqueteCompleto && <span className="individual-price">${Number(cServicio.precio).toFixed(2)}</span>}
          </label>
          )}

          {cNoAdeudo && (
          <label className="custom-egreso-checkbox">
            <input type="checkbox" name="noAdeudo" checked={sel.noAdeudo} onChange={handleCheckboxChange} />
            <span className="custom-checkmark"></span>
            <span className="checkbox-label-text">{cNoAdeudo.concepto}</span>
            {!esPaqueteCompleto && <span className="individual-price">${Number(cNoAdeudo.precio).toFixed(2)}</span>}
          </label>
          )}
        </div>
      </div>

      <div className="FormularioDiplomas-flex">
        <div className="FormularioDiplomas-form">
          <p className="diplomas-title">¿Cuántos Diplomas de Competencias adicionales deseas? {cDiploma && <span className="diplomas-sub">(${Number(cDiploma.precio).toFixed(2)} c/u)</span>}</p>
          <div className="FormularioDiplomas-radios">
            {[0, 1, 2, 3, 4, 5].filter(diplomasDisponibles).map((num) => (
              <label key={num} className="radio-option">
                <input type="radio" name="diplomas" value={num} checked={numDiplomas === num} onChange={(e) => setNumDiplomas(parseInt(e.target.value, 10))} />
                {num === 0 ? "Ninguno" : num}
              </label>
            ))}
          </div>
        </div>

        <div className="FormularioDiplomas-paybox">
          <div className="FormularioDiplomas-total">
            <h4>Total: <span>${Number(precio).toFixed(2)}</span></h4>
          </div>
          
          {error && <div className="Formulario-error"><p>{mensajeError}</p></div>}
          
          {esSoloVentanilla ? (
            <input 
              className="Formulario-boton" 
              type="button" 
              onClick={PrepararPagoVentanilla} 
              value={cargandoPdf ? "PROCESANDO FORMATO..." : "DESCARGAR FORMATO VENTANILLA"} 
              disabled={cargandoPdf}
            />
          ) : (
            <input className="Formulario-boton" type="button" onClick={CrearPagoOnline} value="CONTINUAR" />
          )}
        </div>
      </div>
      </>
      )}
    </div>
  );
};

export default FormularioDiplomas;